import { GET_MACHINE_TYPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_MACHINE_TYPES_SUCCESS: {
      const machineTypes = action.payload;

      if (!machineTypes){
        return [...state];
      }

      return [
        ...state,
        ...machineTypes
      ]
    }
    default:
      return state;
  }
}
